import React from 'react';
import ReactDom from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import I18n from './i18n';
import rootReducer from './services/redux';
import ProviderWithRouter from './ProviderWithRouter';
import { generateAndSetDeviceId } from './services/cookies';
import mockApi from './mock';

if (process.env.IS_MOCK_API) {
  mockApi();
}

generateAndSetDeviceId();

const render = () =>
  ReactDom.render(
    <BrowserRouter>
      <ProviderWithRouter rootReducer={rootReducer}>
        <I18nextProvider i18n={I18n}>
          <App />
        </I18nextProvider>
      </ProviderWithRouter>
    </BrowserRouter>,
    document.getElementById('app')
  );

render(App);

if (module.hot) {
  module.hot.accept('./App', () => render(App));
}



// WEBPACK FOOTER //
// ./src/index.js